<div class="flex min-w-[236px] flex-col gap-2 p-2">
  <div class="flex items-center gap-1">
    @if (vm.statusColor) {
      <lib-appointment-status-chip [statusColor]="vm.statusColor"></lib-appointment-status-chip>
    }

    <span class="typo-h6-semibold w-fit truncate">{{ vm.patientName }}</span>

    <span class="ml-auto min-w-fit text-h8 text-text-tertiary">
      {{ vm.from | timeRangeFormat: vm.to }}
    </span>
  </div>

  @if ((vm.medicalAlerts?.length ?? 0) > 0) {
    <div class="flex items-center gap-1">
      <svg-icon size="sm" key="px-16-medical-alert" class="text-states-deep-red"></svg-icon>
      <span class="text-h8 font-medium">{{ vm.medicalAlerts?.join(', ') }}</span>
    </div>
  }
  @for (alert of vm.patientAlerts; track $index) {
    <div class="flex items-center gap-1">
      <svg-icon size="sm" key="px-16-patient-alert" class="text-states-orange"></svg-icon>
      <span class="text-h8 font-medium">{{ alert }}</span>
    </div>
  }

  <div class="flex items-center gap-1">
    <div class="mx-[4px] h-3 w-2 rounded-sm" [style.background-color]="vm.color"></div>
    @if (vm.pmsProviderId) {
      <span class="text-h8 font-medium">{{ vm.pmsProviderId }}</span>
    }
    <span class="text-h8 text-text-tertiary">{{ vm.providerName }}</span>
  </div>

  @if (vm.reason) {
    <span class="text-h8 font-medium">{{ vm.reason }}</span>
  }

  @if (vm.notes) {
    <span class="line-clamp-2 text-h8 text-text-tertiary">{{ vm.notes }}</span>
  }
</div>
